module.exports = __webpack_public_path__ + "img/physicaleducation-h-474x356.5ab6279d.jpg";